module.exports = __webpack_public_path__ + "img/25b5cce5-efc1-4fab-855c-fd99cd378d78.23736def.png";